import "./v5-home.scss";
import konektavLogo from "../../assets/img/v5-konektav-suite.png";
import litePosLogo from "../../assets/img/v5-lite-pos.png";
import wakaLogo from "../../assets/img/v5-waka-payroll.png";
import agrisenseLogo from "../../assets/img/v5-agrisense.png";
import agrisenseVisual from "../../assets/img/v5-agrisense-visual.png";
import officeVisual from "../../assets/img/v5-office-visual.png";

const heroCity = "/hero-smart-city-island.png?v=20260727-0815";

const Icon = ({ name, size = 22 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };

  const paths = {
    shield: (
      <>
        <path d="M12 3 20 6v5c0 5-3.4 8.5-8 10-4.6-1.5-8-5-8-10V6l8-3Z" />
        <path d="m9 12 2 2 4-4" />
      </>
    ),
    chart: (
      <>
        <path d="M4 19V9" />
        <path d="M10 19V5" />
        <path d="M16 19v-7" />
        <path d="M22 19H2" />
      </>
    ),
    headset: (
      <>
        <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
        <path d="M18 19h1a2 2 0 0 0 2-2v-3h-4v4a1 1 0 0 0 1 1Z" />
        <path d="M6 19H5a2 2 0 0 1-2-2v-3h4v4a1 1 0 0 1-1 1Z" />
      </>
    ),
    leaf: (
      <>
        <path d="M11 20A7 7 0 0 1 9 6c5 0 8 3 8 7a7 7 0 0 1-6 7Z" />
        <path d="M7 21c1-5 4-8 10-10" />
      </>
    ),
    cart: (
      <>
        <circle cx="9" cy="20" r="1" />
        <circle cx="19" cy="20" r="1" />
        <path d="M3 4h2l2.6 11.2A2 2 0 0 0 9.5 17H18a2 2 0 0 0 1.9-1.4L22 8H7" />
      </>
    ),
    factory: (
      <>
        <path d="M3 21V9l6 3V9l6 3V5h6v16Z" />
        <path d="M7 17h.01M11 17h.01M15 17h.01M19 17h.01" />
      </>
    ),
    truck: (
      <>
        <path d="M3 6h11v11H3Z" />
        <path d="M14 10h4l3 3v4h-7Z" />
        <circle cx="7" cy="18" r="2" />
        <circle cx="18" cy="18" r="2" />
      </>
    ),
    hospital: (
      <>
        <path d="M4 21V5h16v16" />
        <path d="M9 9h6M12 6v6M8 21v-4h8v4" />
      </>
    ),
    government: (
      <>
        <path d="M3 10h18M5 10v8M9 10v8M15 10v8M19 10v8M2 21h20M12 3l9 5H3l9-5Z" />
      </>
    ),
    school: (
      <>
        <path d="m2 9 10-5 10 5-10 5L2 9Z" />
        <path d="M6 11v5c3 2 9 2 12 0v-5" />
      </>
    ),
    finance: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M16 8.5c-.8-.8-2-1.2-3.3-1.2-1.8 0-3.2.9-3.2 2.2 0 1.5 1.3 2 3.3 2.4 2 .4 3.2.9 3.2 2.4 0 1.4-1.4 2.4-3.4 2.4-1.5 0-2.9-.5-3.8-1.4M12.5 5.5v13" />
      </>
    ),
    briefcase: (
      <>
        <rect x="3" y="7" width="18" height="13" rx="2" />
        <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18M10 12v2h4v-2" />
      </>
    ),
    arrow: (
      <>
        <path d="M5 12h14" />
        <path d="M13 6l6 6-6 6" />
      </>
    ),
    check: <path d="m5 12 4 4L19 6" />,
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const products = [
  {
    name: "KonekTaV Suite",
    subtitle: "ERP / Business Management Solution",
    logo: konektavLogo,
    accent: "#087c45",
    href: "/konektav-lite-pos",
    description:
      "Integrated ERP to manage finance, inventory, HR, procurement, sales, purchasing, and operations in one platform.",
  },
  {
    name: "Lite-POS",
    subtitle: "Point-of-Sale & Ordering Solution",
    logo: litePosLogo,
    accent: "#ff7900",
    href: "/konektav-lite-pos",
    description:
      "Fast, reliable, and easy-to-use POS software for retail, restaurants, and online ordering.",
  },
  {
    name: "Waka Payroll",
    subtitle: "Payroll & HR Management",
    logo: wakaLogo,
    accent: "#5c46ff",
    href: "/waka-payroll",
    description:
      "Automated payroll, attendance, benefits, and compliance-accurately and securely.",
  },
  {
    name: "Agrisense",
    subtitle: "Smart Agriculture / Soil Monitoring",
    logo: agrisenseLogo,
    accent: "#378f24",
    href: "/agrisense-mobile",
    description:
      "IoT-powered soil and weather intelligence that turns field data into better decisions.",
  },
  {
    name: "IT Consultancy",
    subtitle: "System Integration & Advisory",
    icon: "briefcase",
    accent: "#6044b8",
    description:
      "Expert technology strategy, implementation, integration, and end-to-end support.",
  },
];

const industries = [
  ["leaf", "Agriculture"],
  ["cart", "Retail & F&B"],
  ["factory", "Manufacturing"],
  ["truck", "Logistics & Fleet"],
  ["hospital", "Healthcare"],
  ["government", "Government"],
  ["school", "Education"],
  ["finance", "Finance"],
];

function Dashboard() {
  return (
    <div className="dashboard" aria-label="KonekTaV Suite dashboard preview">
      <div className="dashboard__head">
        <strong>Overview</strong>
        <span>Live Dashboard</span>
      </div>
      <div className="dashboard__metrics">
        <div><span>Sales Growth</span><b>+32.5%</b></div>
        <div><span>Expenses</span><b>28.5 C</b></div>
        <div><span>Active Users</span><b>45.6K</b></div>
        <div><span>Performance</span><b>97.4%</b></div>
      </div>
      <div className="dashboard__body">
        <div className="chartBox">
          <span>Sales Trend</span>
          <svg viewBox="0 0 340 120" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0 95 48 45 95 78 145 36 198 65 248 30 300 48 340 22" />
            <path className="area" d="M0 95 48 45 95 78 145 36 198 65 248 30 300 48 340 22V120H0Z" />
          </svg>
          <div className="months"><i>Jan</i><i>Feb</i><i>Mar</i><i>Apr</i><i>May</i><i>Jun</i></div>
        </div>
        <div className="mapBox">
          <span>Business Locations</span>
          <div className="mapGrid"></div>
          {[[18, 28], [42, 62], [67, 35], [78, 70], [55, 48]].map(([left, top], index) => (
            <i key={index} style={{ left: `${left}%`, top: `${top}%` }} />
          ))}
        </div>
      </div>
      <button className="dashboard__button">Learn More <Icon name="arrow" size={15} /></button>
    </div>
  );
}

export default function HomePage() {
  return (
    <main id="home" className="v5-home">
      <section className="hero" id="homeTop">
        <div className="shell hero__grid">
          <div className="hero__copy">
            <h1>Smart Technology.<br /><span>Powerful Business.</span></h1>
            <p>Digital solutions that connect operations, people, and data&mdash;helping your business grow smarter and faster.</p>
            <div className="hero__actions">
              <a className="button" href="#solutions">Explore Solutions <Icon name="arrow" size={17} /></a>
              <a className="button button--outline" href="#contact">Request a Demo</a>
            </div>
            <div className="trustRow">
              <div><Icon name="shield" /><span>Trusted Partner<br /><b>You Can Count On</b></span></div>
              <div><Icon name="chart" /><span>Proven Solutions<br /><b>Across Industries</b></span></div>
              <div><Icon name="headset" /><span>Local Support<br /><b>Real Results</b></span></div>
            </div>
          </div>
          <div className="hero__visual">
            <img src={heroCity} alt="Floating smart city with renewable energy, cloud systems and connected business icons" />
          </div>
        </div>
      </section>

      <section className="featured shell" aria-labelledby="featured-title">
        <div className="featured__content">
          <span className="badge">FEATURED SOLUTION</span>
          <div className="featured__title">
            <img src={konektavLogo} alt="KonekTaV Suite logo" />
            <div>
              <h2 id="featured-title">KonekTaV Suite</h2>
              <h3>ERP / Business Management Solution</h3>
            </div>
          </div>
          <p>Integrated ERP to manage finance, inventory, HR, procurement, sales, purchasing, and more&mdash;all in one platform.</p>
          <div className="checkGrid">
            <span><Icon name="check" size={16} />End-to-End Integration</span>
            <span><Icon name="check" size={16} />Scalable & Secure</span>
            <span><Icon name="check" size={16} />Real-time Insights</span>
            <span><Icon name="check" size={16} />Built for Growth</span>
          </div>
        </div>
        <Dashboard />
      </section>

      <section className="solutions shell" id="solutions">
        <div className="sectionHeading">
          <h2>Our Solutions</h2>
          <p>End-to-end digital solutions built to power every part of your business.</p>
        </div>
        <div className="productGrid">
          {products.map((product) => (
            <article className="productCard" key={product.name} style={{ "--accent": product.accent }}>
              <div className="productCard__logo">
                {product.logo ? <img src={product.logo} alt={`${product.name} logo`} /> : <Icon name={product.icon} size={54} />}
              </div>
              <h3>{product.name}</h3>
              <h4>{product.subtitle}</h4>
              <p>{product.description}</p>
              <a href={product.href || "#contact"}>Learn more <Icon name="arrow" size={14} /></a>
            </article>
          ))}
        </div>
      </section>

      <section className="serviceBand" id="industries">
        <div className="shell serviceBand__grid">
          <div className="industryPanel">
            <h2>Industries We Serve</h2>
            <div className="industryIcons">
              {industries.map(([icon, label]) => (
                <div key={label}><Icon name={icon} /><span>{label}</span></div>
              ))}
            </div>
          </div>
          <div className="whyPanel" id="why-brandv">
            <h2>Why Choose BR&V?</h2>
            <div className="whyList">
              <span><Icon name="check" />Proven Expertise</span>
              <span><Icon name="check" />Tailored Solutions</span>
              <span><Icon name="check" />End-to-End Support</span>
              <span><Icon name="check" />Innovation Driven</span>
            </div>
          </div>
        </div>
      </section>

      <section className="agriFeature">
        <div className="agriFeature__visual">
          <img src={agrisenseVisual} alt="Agrisense field monitoring dashboard and sensor" />
          <div className="agriDashboard" aria-hidden="true">
            <div className="agriDashboard__top">
              <span>Overview</span>
              <strong>Live Field</strong>
            </div>
            <div className="agriDashboard__metrics">
              <div><span>Soil Moisture</span><b>62%</b></div>
              <div><span>Soil Temp.</span><b>28.5 C</b></div>
              <div><span>pH Level</span><b>6.4</b></div>
              <div><span>Air Temp.</span><b>27.8 C</b></div>
            </div>
            <div className="agriDashboard__panels">
              <div className="agriChart">
                <span>Field Trend</span>
                <svg viewBox="0 0 300 112" preserveAspectRatio="none">
                  <defs>
                    <linearGradient id="agriTrendFill" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#0c8a52" stopOpacity="0.28" />
                      <stop offset="100%" stopColor="#0c8a52" stopOpacity="0.02" />
                    </linearGradient>
                  </defs>
                  <path className="agriChart__fill" d="M12 78 L55 52 L96 28 L140 58 L182 32 L224 49 L270 22 L288 38 L288 100 L12 100 Z" />
                  <path className="agriChart__line" d="M12 78 L55 52 L96 28 L140 58 L182 32 L224 49 L270 22 L288 38" />
                  <g className="agriChart__points">
                    <circle cx="12" cy="78" r="4" />
                    <circle cx="96" cy="28" r="4" />
                    <circle cx="182" cy="32" r="4" />
                    <circle cx="270" cy="22" r="4" />
                  </g>
                </svg>
                <div className="agriChart__months"><span>Jan</span><span>Feb</span><span>Mar</span><span>Apr</span><span>May</span><span>Jun</span></div>
              </div>
              <div className="agriMap">
                <span>Irrigation Map</span>
                <i style={{ "--x": "18%", "--y": "38%" }} />
                <i style={{ "--x": "45%", "--y": "67%" }} />
                <i style={{ "--x": "71%", "--y": "26%" }} />
                <i style={{ "--x": "84%", "--y": "55%" }} />
              </div>
            </div>
          </div>
        </div>
        <div className="agriFeature__copy">
          <div className="agriFeature__brand"><img src={agrisenseLogo} alt="Agrisense logo" /><h2>Agrisense</h2></div>
          <h3>Smarter Farming. Better Outcomes.</h3>
          <p>Real-time soil and weather insights help farmers optimize irrigation, increase yields, and reduce risk.</p>
          <ul>
            <li>Real-time field monitoring</li>
            <li>AI-powered recommendations</li>
            <li>Weather alerts and mobile access</li>
            <li>Cloud dashboards and analytics</li>
          </ul>
          <a className="button button--light" href="#contact">Learn More About Agrisense <Icon name="arrow" size={16} /></a>
        </div>
      </section>

      <section className="about" id="about-us">
        <div className="about__visual"><img src={officeVisual} alt="BR&V Technology office" /></div>
        <div className="about__content">
          <div>
            <h2>About BR&V Technology Corp.</h2>
            <p>We are a technology company committed to delivering innovative and reliable digital solutions that help organizations operate smarter, serve better, and grow stronger.</p>
          </div>
          <div className="stats">
            <div><b>10+</b><span>Years in Business</span></div>
            <div><b>100+</b><span>Projects Completed</span></div>
            <div><b>50+</b><span>Happy Clients</span></div>
            <div><b>24/7</b><span>Support & Maintenance</span></div>
          </div>
          <a className="button button--compact" href="#contact">Learn More About Us</a>
        </div>
      </section>

      <section className="cta" id="contact">
        <div className="shell">
          <h2>Let's Build Something Great Together</h2>
          <p>Have a project in mind or want to learn more about our solutions?</p>
          <a className="button button--light" href="mailto:contact@brvtechnologysg.com">Get in Touch Today <Icon name="arrow" size={16} /></a>
        </div>
      </section>
    </main>
  );
}
